export const loadTrelloClient = async () => {
  window.opts = {
    authEndpoint: 'https://trello.com',
    apiEndpoint: 'https://api.trello.com',
    version: 1,
    key: '94825ee121ac119646bda8c25ae89f19' // account tsds
  }
  await loadScript('/js/lib/jquery-3.3.1.min.js')
  await loadScript('/js/lib/trello-client.js')
}

const loadScript = (src: string) => {
  return new Promise<void>((resolve, reject) => {
    const script = document.createElement('script')
    script.src = src
    script.addEventListener('load', () => resolve())
    script.addEventListener('error', reject)
    document.body.appendChild(script)
  })
}

export const authenticateTrello = (
  onSuccess: () => void,
  onError: (error: Error) => void
) => {
  window.Trello.authorize({
    type: 'popup',
    name: 'YouGile',
    scope: {read: 'true'},
    expiration: '1hour',
    success: onSuccess,
    error: onError
  })
}
